// dependencies
import React from "react";

// components
import Link from "../Link";
import Typography from "../Text";
// css
import css from "./SideNavigation.module.scss";

export type SideNavigationLink = {
	label: string;
	href: string;
	key: string;
	fullPageLoad?: boolean;
};

type SideNavigationProps = {
	items?: SideNavigationLink[];
	activeKey?: string;
};

const SideNavigation = ({ items = [], activeKey = "" }: SideNavigationProps) => {
	const renderedLinkList = items.map((item) => (
		<Link key={item.key} href={item.href} noUnderline forceHardReload={item.fullPageLoad}>
			<div className={`${css.pageControlsItem} ${activeKey === item.key && css.active}`}>
				<Typography size="caption" weight="semi-bold">
					{item.label}
				</Typography>
			</div>
		</Link>
	));
	return <div className={css.pageControlsContainer}>{renderedLinkList}</div>;
};

export default SideNavigation;
